import {
    REPORT_LIST_CACHED_RESPONSE,
    REPORT_LIST_ERROR_RESPONSE,
    REPORT_LIST_REQUEST,
    REPORT_LIST_RESPONSE
} from "./action-types"
import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"

// Paging Actions
export const reportListRequest = listRequest(REPORT_LIST_REQUEST)
export const reportListResponse = listResponse(REPORT_LIST_RESPONSE)
export const reportListCachedResponse = listCachedResponse(
    REPORT_LIST_CACHED_RESPONSE
)
export const reportListErrorResponse = listErrorResponse(
    REPORT_LIST_ERROR_RESPONSE
)
